import { AppShell, usePriceTypeOptions } from '@autone/ui';
import {
  ASSORTMENT_ADMIN,
  ASSORTMENT_READONLY,
  ASSORTMENT_STANDARD,
} from '@autone/utils';
import { RouterProvider } from '@tanstack/react-router';

import { useReleaseAssortmentIAFlag } from './flags/useReleaseAssortmentIAFlag';
import { APP_NAME } from './old/consts';
import store from './old/redux/store';
import { router } from './router';

const App = () => {
  usePriceTypeOptions();

  return (
    <AppShell
      module={APP_NAME}
      reduxStore={store}
      translationNamespace={APP_NAME}
      permissionGroups={[
        ASSORTMENT_ADMIN,
        ASSORTMENT_READONLY,
        ASSORTMENT_STANDARD,
      ]}
      editPermissions={null}
      permissions={{
        admin: [ASSORTMENT_ADMIN],
        edit: [ASSORTMENT_ADMIN, ASSORTMENT_STANDARD],
      }}
    >
      <AssortmentRouterProvider />
    </AppShell>
  );
};

export default App;

const AssortmentRouterProvider = () => {
  const releaseAssortmentIA: boolean = useReleaseAssortmentIAFlag();
  return <RouterProvider router={router} context={{ releaseAssortmentIA }} />;
};
